const serviceData = [
  {
    icon: "ri-truck-line",
    title: "Free Shipping",
    subtitle: "Free Shipping Worldwide - Free Shipping On All Products",
    bg: "#fdefe6",
  },
  {
    icon: "ri-refresh-line",
    title: "Easy Returns",
    subtitle: "Goods may be returned within 14 days of our despatch date.",
    bg: "#ceebe9",
  },
  {
    icon: "ri-secure-payment-line",
    title: "Secure Payment",
    subtitle: "Credit/Debit Cards, Online, Offline cash Payments at the store",
    bg: "#e2f2b2",
  },
  {
    icon: "ri-exchange-dollar-line",
    title: " Back Guarantee",
    subtitle: "We will refund your purchase in full with less transport costs.",
    bg: "#d6e5fb",
  },
];

export default serviceData;
